import React, { Fragment, useEffect, useRef } from "react";
import PropTypes from "prop-types";

const PopupSuccess = ({ showPopupSuccess, setShowPopupSuccess, textHeader, textBody }) => {
  const progressBarRef = useRef(null);
  
  useEffect(() => {
    if (showPopupSuccess) {
      const progressBar = progressBarRef.current;
      if (progressBar) {
        progressBar.style.width = '0%';
        setTimeout(() => {
          progressBar.style.width = '100%';
        }, 10);
        
        const timer = setTimeout(() => {
          setShowPopupSuccess(false);
        }, 3000);
        
        return () => clearTimeout(timer);
      }
    }
  }, [showPopupSuccess, setShowPopupSuccess]);

  if (!showPopupSuccess) return null;
  
  return (
    <Fragment>
      <div className="popup-overlay">
        <div className="popup-success-container">
          <div className="popup-success-content">
            <div className="popup-header">
              <i className="fa fa-check-circle success-icon" />
              <h5 className="popup-title">{textHeader}</h5>
            </div>
            <div className="popup-body">
              {textBody}
            </div>
            <div 
              ref={progressBarRef}
              className="popup-progress-bar"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

PopupSuccess.propTypes = {
  showPopupSuccess: PropTypes.bool,
  setShowPopupSuccess: PropTypes.func,
  textHeader: PropTypes.string,
  textBody: PropTypes.string,
};

export default PopupSuccess;
